import PageSpeedPerformance from "../../../../components/AssetManagement/Health/PageSpeedPerformance/PageSpeedPerformance";

export default function PageSpeedPerformanceScreen() {
  return (
    <>
      <PageSpeedPerformance />
    </>
  );
}
